import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikTidsforbrugViewModel } from '../../models/statistikTidsforbrugViewModel';
import { StatistikService } from '../../statistik.service';
import { Observable } from 'rxjs';
import { StatistikTidsforbrugIkkeKunderelateretTidModalViewModel } from '../../models/StatistikTidsforbrugIkkeKunderelateretTidModalViewModel';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-statistik-tidsforbrug-ikke-kunderelateret-tid-modal-ui',
    templateUrl: './statistik-tidsforbrug-ikke-kunderelateret-tid-modal.component.html',
    styleUrls: ['./statistik-tidsforbrug-ikke-kunderelateret-tid-modal.component.scss'],
    standalone: false
})
export class StatistikTidsforbrugIkkeKunderelateretTidModalComponent implements OnInit {
    title: string;
    pid: number;
    medarbejder: StatistikTidsforbrugViewModel;
    selectedPeriod: { fra: string, til: string };
    totalHours = 0;

    IkkeKunderelateretTidViewList$: Observable<StatistikTidsforbrugIkkeKunderelateretTidModalViewModel[]>;

    constructor(private activeModal: NgbActiveModal,
                private statistikService: StatistikService) {
    }

    ngOnInit(): void {
        this.IkkeKunderelateretTidViewList$ = this.statistikService.getTidsforbrugIkkeKunderelateretTid(this.medarbejder.medID, this.pid, this.selectedPeriod);
        this.getTotalHours();
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    getTotalHours() {
        this.IkkeKunderelateretTidViewList$.pipe(
            map(ikrtList => ikrtList.reduce((total, ikrt) => total + ikrt.timer, 0))
        ).subscribe(total => this.totalHours = total);
    }
}







